export default {
  /**
   * 로그 이벤트 종류(lms_event 테이블 event_type 컬럼값)
   * @type {Object}
   */
  EVENT_TYPE: {
    KEYWORD_COUNT: 'KEYWORD_COUNT',
    BASELINE: 'BASELINE',
    UNKNOWN_PATTERN: 'UNKNOWN_PATTERN',
    ML_PATTERN: 'ML_PATTERN',
    STORAGE: 'STORAGE',
  },
  /**
   * 로그 관련 interval 상수
   * @type {Object}
   */
  TIME_INTERVAL: {
    D: 'D',
    H: 'H',
    M: 'M',
    S: 'S',
  },
};



// WEBPACK FOOTER //
// ./src/views/log-analysis/Event/js/event-constant.js